import * as React from 'react';
import './spinner.css';
export const Spinner = ({ full }) => (React.createElement("div", { className: full ? 'spinner full' : 'spinner' },
    React.createElement("div", { className: "rect1" }),
    React.createElement("div", { className: "rect2" }),
    React.createElement("div", { className: "rect3" }),
    React.createElement("div", { className: "rect4" }),
    React.createElement("div", { className: "rect5" })));
